export default __webpack_public_path__ + "static/media/GR6 3A-1B-1C-1D-2EC.63bab2aa.jpg";